import React from 'react';
import { Star } from 'lucide-react';
import Container from '../ui/Container';
import SectionTitle from '../ui/SectionTitle';
import { DATA } from '../../data';
import { Review } from '../../types';

const Reviews: React.FC = () => (
  <section id="reviews" className="py-24 lg:py-36 2xl:py-48 bg-brand-white sticky top">
    <div className="grid-system !gap-0">
      <div className="grid-text mb-16">
        <SectionTitle 
          title="Отзывы учеников" 
          subtitle="Реальные истории людей, которые начали танцевать с нуля" 
        />
      </div>
      
      <div className="grid-content">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 2xl:gap-12">
          {DATA.reviews.map((rev: Review) => (
            <div key={rev.id} className="bg-brand-secondary backdrop-blur-md p-8 rounded-4xl transition-all relative">
                <div className="flex gap-1 mb-6 mt-4">
                  {[...Array(rev.stars)].map((_, i) => (
                    <Star key={i} size={18} className="fill-brand-primary text-brand-primary" />
                  ))}
                </div>
                <p className="body-base md:body-lg text-brand-white leading-relaxed font-medium mb-6 relative z-10">
                  {rev.text}
                </p>
                <div className="flex items-center gap-4 border-t border-brand-white/50 pt-6">
                  <div className="w-10 h-10 bg-brand-primary rounded-full flex items-center justify-center text-brand-white font-bold">
                    {rev.name[0]}
                  </div>
                  <div>
                    <p className="font-bold text-brand-white ui-base">{rev.name}</p>
                    <p className="caption-sm text-brand-white/50">Ученик Fun dance</p>
                  </div>
                </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Reviews;